import { useQuery } from "@tanstack/react-query";
import { berserkr, isSupabaseConfigured } from "../lib/supabase";

/** One toggleable piece of evidence. Mirrors berserkr.fetch_case_evidence_inventory. */
export interface InventoryItem {
  item_kind: "evidence" | "filing";
  item_id: string;
  sub_kind: string;       // email | text_message | filing
  category: string;       // communications | trust_corporate | financial | public_regulatory | document
  label: string;
  message_count: number;
  first_at: string | null;
  last_at: string | null;
  included: boolean;
  reason: string | null;
}

/** Every ingested piece for the case, with its current on/off state. */
export function useCaseEvidenceInventory(caseId: string | undefined) {
  return useQuery<InventoryItem[], Error>({
    queryKey: ["case-evidence-inventory", caseId],
    enabled: isSupabaseConfigured() && !!caseId,
    staleTime: 60 * 1000,
    queryFn: async () => {
      if (!caseId) return [];
      const { data, error } = await berserkr().rpc("fetch_case_evidence_inventory", {
        p_case_id: caseId,
      });
      if (error) throw new Error(error.message);
      return (data as InventoryItem[]) ?? [];
    },
  });
}
